import {
    getFb,
    getAreaByWsp,
    getConversationFromNumber,
} from 'src/utils/areas/getDataAreas';
import { NEW_AREA } from 'src/constants/store/areas';
import {
    API_TWILIO,
    API_WSP,
    WHATSAPP_CHANNEL,
    MESSENGER_CHANNEL,
} from 'src/constants/conversations';
import { IConversation } from 'src/interfaces/conversation';

interface IChannelResponse {
    from: string;
    api?: typeof API_TWILIO | typeof API_WSP;
}

interface IFromHandler {
    getChannelData(conversation: IConversation): IChannelResponse;
}

class MessengerFromHandler implements IFromHandler {
    getChannelData(conversation: IConversation): IChannelResponse {
        const response = getFb({
            area: conversation.area,
            areas: conversation.store.areas || [],
        });

        return {
            from: response.fb,
            api: API_TWILIO,
        };
    }
}

class WhatsappFromHandler implements IFromHandler {
    getChannelData(conversation: IConversation): IChannelResponse {
        const response = getAreaByWsp({
            area: conversation.area || NEW_AREA,
            areas: conversation.store.areas || [],
        });

        if (response?.api === API_TWILIO) {
            return {
                from: getConversationFromNumber({
                    channel: WHATSAPP_CHANNEL,
                    area: conversation.area || NEW_AREA,
                    areas: conversation.store.areas,
                }),
                api: API_TWILIO,
            };
        }

        if (response?.api === API_WSP) {
            return {
                from: response.whatsapp,
                api: API_WSP,
            };
        }

        return {
            from: '',
        };
    }
}

export class FromHandlerFactory {
    static create(channel: string): IFromHandler | null {
        switch (channel) {
            case MESSENGER_CHANNEL:
                return new MessengerFromHandler();
            case WHATSAPP_CHANNEL:
                return new WhatsappFromHandler();
            default:
                return null;
        }
    }
}
